import { render, staticRenderFns } from "./Nmc.vue?vue&type=template&id=7a5b68d4"
import script from "./Nmc.vue?vue&type=script&lang=js"
export * from "./Nmc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports